import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../services/auth.service';
import { default as ReactSelect, components } from "react-select";
import axios from 'axios';
import styled from '@emotion/styled';
import {
    Box,
    Typography,
    Avatar,
    TextField,
    Button,
    Chip,
    IconButton,
    LinearProgress,
    Slide,
    Zoom
} from '@mui/material';
import {
    WhatsApp as WhatsAppIcon,
    Send as SendIcon,
    AccessTime as TimeIcon,
    Person as PersonIcon,
    LocalOffer as TagIcon,
    EmailOutlined as EmailIcon,
    PhoneOutlined as PhoneIcon,
    ConfirmationNumberOutlined as TicketIcon,
    Add as AddIcon,
    Clear as ClearIcon,
    Description as TemplateIcon
} from '@mui/icons-material';

const SidebarContainer = styled(Box)(({ theme }) => ({
    width: '25%',
    minWidth: '320px',
    height: '100%',
    backgroundColor: '#ffffff',
    borderLeft: '1px solid #e9edef',
    overflowY: 'auto',
    padding: '24px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    fontFamily: 'Inter, Roboto, Arial, sans-serif',
    '&::-webkit-scrollbar': {
        width: '5px',
    },
    '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#cccccc',
        borderRadius: '3px',
    },
}));

const ContactHeader = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    padding: '16px',
    backgroundColor: '#f8f9fa',
    borderRadius: '16px',
    border: '1px solid #f0f2f5',
}));

const ContactInfo = styled(Box)(({ theme }) => ({
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
}));

const SectionBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    paddingBottom: '16px',
    borderBottom: '1px solid #f0f2f5',
}));

const SectionHeaderLabel = styled(Typography)(({ theme }) => ({
    fontSize: '11px',
    fontWeight: 700,
    color: '#8696a0',
    letterSpacing: '0.6px',
    textTransform: 'uppercase',
}));

const CustomDropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <AddIcon sx={{ color: '#8696a0', fontSize: 18 }} />
        </components.DropdownIndicator>
    );
};

const ReactSelectCustom = styled(ReactSelect)`
    .react-select__control {
        border: 1px solid #e9edef !important;
        border-radius: 14px !important;
        font-size: 13px !important;
        font-weight: 600 !important;
        min-height: 42px !important;
        background-color: #f8f9fa !important;
        box-shadow: none !important;
        cursor: pointer !important;
        padding-left: 6px !important;
        padding-right: 6px !important;
        transition: all 0.2s ease !important;
        &:hover {
            background-color: #f0f2f5 !important;
            border-color: #8696a0 !important;
        }
        &--is-focused {
            background-color: #ffffff !important;
            border-color: #008069 !important;
            box-shadow: 0 0 0 2px rgba(0, 128, 105, 0.15) !important;
        }
    }
    .react-select__placeholder {
        color: #8696a0 !important;
        font-size: 13px !important;
        font-weight: 600 !important;
    }
    .react-select__single-value {
        color: #111b21 !important;
        font-weight: 600 !important;
        font-size: 13px !important;
    }
    .react-select__indicator-separator {
        display: none !important;
    }
    .react-select__dropdown-indicator {
        padding: 4px !important;
    }
    .react-select__menu {
        font-size: 13px !important;
        border-radius: 14px !important;
        z-index: 9999 !important;
        border: 1px solid #e9edef !important;
        box-shadow: 0 8px 24px rgba(0,0,0,0.08) !important;
        overflow: hidden !important;
    }
    .react-select__option {
        padding: 10px 14px !important;
        cursor: pointer !important;
    }
`;

export default function SidebarInfo(props) {
    const { t } = useTranslation();
    const [name, setName] = useState(props.contact?.NombreCompleto ? props.contact?.NombreCompleto : props.contact?.Celular || "");
    const [number, setNumber] = useState(props.contact?.Celular || "");
    const [notas, setNotas] = useState(props.contact?.notas ? props.contact?.notas : "");
    const [etiquetas, setEtiquetas] = useState([]);
    const [selectedTags, setSelectedTags] = useState(props.contact?.etiquetas ? props.contact?.etiquetas : []);
    const [updating, setUpdating] = useState(false);
    const [ejecutivoAsignado, setEjecutivoAsignado] = useState(() => {
        const initial = props.contact?.ejecutivoAsignado;
        if (!initial) return [];
        return Array.isArray(initial) ? initial : [initial];
    });
    const [sucursalChat, setSucursalChat] = useState(props.contact?.sucursalChat ? props.contact?.sucursalChat : []);
    const [cbp, setCBP] = useState(props.contact?.conversation ? props.contact?.conversation : []);
    const [templates, setTemplates] = useState([]);
    const [plantillaSeleccionada, setPlantillaSeleccionada] = useState(null);
    const { user } = useAuth();
    const [ejecutivos, setEjecutivos] = useState([]);
    const [expirationTimer, setExpirationTimer] = useState([]);
    const [expirationWidth, setExpirationWidth] = useState([]);
    const [expirationType, setExpirationType] = useState([]);
    const [timer, setTimer] = useState(undefined);

    useEffect(() => {
        setName(props.contact?.NombreCompleto ? props.contact?.NombreCompleto : props.contact?.Celular || "");
        setNumber(props.contact?.Celular || "");
        setNotas(props.contact?.notas ? props.contact?.notas : "");
        setSelectedTags(props.contact?.etiquetas ? props.contact?.etiquetas : []);
        const initialEj = props.contact?.ejecutivoAsignado;
        setEjecutivoAsignado(initialEj ? (Array.isArray(initialEj) ? initialEj : [initialEj]) : []);
        setSucursalChat(props.contact?.sucursalChat ? props.contact?.sucursalChat : []);
        setCBP(props.contact?.conversation ? props.contact?.conversation : []);

        async function fetchEtiquetas() {
            try {
                let url = `${process.env.REACT_APP_BACKEND_API}/tag`;
                let config = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        "x-access-token": user.accessToken,
                    },
                };

                const response = await axios.get(url, config);
                let newEtiquetas = response.data.map((etiqueta) => {
                    return { value: etiqueta._id, label: etiqueta.name, selected: false };
                });
                setEtiquetas(newEtiquetas);
            } catch (error) {
                console.log(error);
            }
        }
        fetchEtiquetas();

        async function fetchTemplates() {
            try {
                let url = `${process.env.REACT_APP_BACKEND_API}/template`;
                let config = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        "x-access-token": user.accessToken,
                    },
                };

                const response = await axios.get(url, config);
                let newTemplates = response.data.map((template) => {
                    let isImageOrVideo = template['image-video-select'] ? template['image-video-select'].value : null;
                    if (isImageOrVideo === "image") {
                        return { value: template._id, label: template.name, image: template.image, video: "" };
                    } else if (isImageOrVideo === "video") {
                        return { value: template._id, label: template.name, video: template.video, image: "" };
                    } else {
                        return { value: template._id, label: template.name, video: template.video, image: template.image };
                    }
                });
                setTemplates(newTemplates);
            } catch (error) {
                console.log(error);
            }
        }
        fetchTemplates();
    }, [props.contact?.Celular]);

    useEffect(() => {
        if (updating) updateContactInfo();
    }, [updating]);

    useEffect(() => {
        if (cbp && cbp.length > 0) {
            setExpirationTimer([]);
            setExpirationWidth([]);
            setExpirationType([]);
            if (timer) clearInterval(timer);
            setTimer(
                setInterval(() => {
                    expirationFunction();
                }, 10000)
            );
            const expirationFunction = () => {
                let tempExpirationTimer = [];
                let tempExpirationWidth = [];
                let tempExpirationType = [];
                let expiredTimers = 0;

                if (props.contact?.conversation) {
                    props.contact.conversation.forEach((conversation, idx) => {
                        let expirationTime = new Date(conversation.expiration_timestamp * 1000);
                        let now = new Date();
                        let timeLeft = expirationTime - now;
                        let skip = false;
                        if (timeLeft <= 0) {
                            tempExpirationTimer.splice(idx, 1);
                            tempExpirationWidth.splice(idx, 1);
                            expiredTimers++;
                            if (timer && expiredTimers === props.contact.conversation.length) clearInterval(timer);
                            skip = true;
                        }
                        if (!skip) {
                            let hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                            let minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
                            tempExpirationTimer.push(hours + "h " + minutes + "m");
                            tempExpirationWidth.push(parseInt((hours / 24) * 100) + "%");
                            tempExpirationType.push(conversation.origin.type);
                        }
                    });
                }
                setExpirationTimer(tempExpirationTimer);
                setExpirationWidth(tempExpirationWidth);
                setExpirationType(tempExpirationType);
            };
            expirationFunction();
        } else {
            setExpirationTimer([]);
            setExpirationWidth([]);
            setExpirationType([]);
            if (timer) clearInterval(timer);
        }
    }, [cbp]);

    useEffect(() => {
        async function fetchEjecutivos() {
            try {
                const url = `${process.env.REACT_APP_BACKEND_API}/ejecutivo`;
                const config = {
                    headers: {
                        'x-access-token': user.accessToken,
                        'Content-Type': 'application/json',
                    }
                };
                const response = await axios.get(url, config);
                let newEjecutivos = response.data.map((ejecutivo) => {
                    return { value: ejecutivo._id, label: ejecutivo.firstName + " " + ejecutivo.lastName };
                });
                setEjecutivos(newEjecutivos);
            } catch (error) {
                console.log(error);
            }
        }
        fetchEjecutivos();
    }, [sucursalChat]);

    function updateContactInfo() {
        setUpdating(false);
        fetch(`${process.env.REACT_APP_BACKEND_API}/contacts/${number}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                "x-access-token": user.accessToken,
            },
            body: JSON.stringify({
                wa_id: number,
                NombreCompleto: name,
                notas: notas,
                etiquetas: selectedTags,
                ejecutivoAsignado: ejecutivoAsignado,
                sucursalChat: sucursalChat,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                console.log('Success:', data);
                if (props.onUpdateContact) {
                    props.onUpdateContact(number, { NombreCompleto: name, notas: notas, etiquetas: selectedTags, ejecutivoAsignado: ejecutivoAsignado, sucursalChat: sucursalChat }, props.contact?.inboxtype);
                }
            });
    }

    const removeTag = (tagToRemove) => {
        const updated = selectedTags.filter(t => (t.value || t.label || t) !== (tagToRemove.value || tagToRemove.label || tagToRemove));
        setSelectedTags(updated);
        setUpdating(true);
    };

    const addTag = (newTag) => {
        if (!newTag) return;
        if (!selectedTags.some(t => (t.value || t.label || t) === (newTag.value || newTag.label || newTag))) {
            const updated = [...selectedTags, newTag];
            setSelectedTags(updated);
            setUpdating(true);
        }
    };

    const removeEjecutivo = (ejecutiveToRemove) => {
        const targetVal = ejecutiveToRemove.value || ejecutiveToRemove._id || ejecutiveToRemove;
        const currentArr = Array.isArray(ejecutivoAsignado) ? ejecutivoAsignado : [];
        const updated = currentArr.filter(e => (e.value || e._id || e) !== targetVal);
        setEjecutivoAsignado(updated);
        setUpdating(true);
    };

    const addEjecutivo = (newEjecutivo) => {
        if (!newEjecutivo) return;
        const currentArr = Array.isArray(ejecutivoAsignado) ? ejecutivoAsignado : [];
        if (!currentArr.some(e => (e.value || e._id || e) === (newEjecutivo.value || newEjecutivo._id || newEjecutivo))) {
            const updated = [...currentArr, newEjecutivo];
            setEjecutivoAsignado(updated);
            setUpdating(true);
        }
    };

    const selectTemplate = (newTemplate) => {
        setPlantillaSeleccionada(newTemplate);
    };

    const contactEmail = props.contact?.email || props.contact?.asegurado?.email || props.contact?.CorreoElectronico || "dianne@example.com";
    const formattedPhone = number ? (number.length === 11 ? `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}` : number) : "(222) 012-2828";
    const ticketStatus = props.contact?.ticketStatus || "ABIERTO";
    const supportSummary = notas || props.contact?.supportSummary || "El cliente reporta dudas sobre la configuración de la plantilla de WhatsApp Business API.";
    const previousProducts = props.contact?.productos || ["Plan Pro", "WhatsApp API Gold"];

    let isJson = false;
    let parsedJson = null;
    try {
        if (notas && typeof notas === 'string' && (notas.trim().startsWith('{') || notas.trim().startsWith('['))) {
            parsedJson = JSON.parse(notas);
            isJson = typeof parsedJson === 'object' && parsedJson !== null;
        }
    } catch (e) {
        isJson = false;
    }

    return (
        <Slide direction="left" in={true} timeout={300}>
            <SidebarContainer>
                {!number ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', textAlign: 'center', p: 3 }}>
                        <Avatar sx={{ width: 64, height: 64, bgcolor: '#f0f8f5', color: '#008069', mb: 2 }}>
                            <PersonIcon sx={{ fontSize: 36 }} />
                        </Avatar>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#111b21' }}>
                            {t('sidebar.noContactSelected')}
                        </Typography>
                    </Box>
                ) : (
                    <>
                        {/* Header Profile */}
                        <ContactHeader>
                            <Avatar
                                src={process.env.REACT_APP_APP_LOGO || "https://firebasestorage.googleapis.com/v0/b/segenesis-cotizador.appspot.com/o/notificaciones%2FGenesisLOGO%20vida%20y%20salud%20(1).png?alt=media&token=2e7ce64b-a316-4579-b3de-37468e2fa470"}
                                sx={{ width: 52, height: 52, bgcolor: '#008069', fontSize: '18px', fontWeight: 600 }}
                            >
                                {name ? name.charAt(0).toUpperCase() : 'C'}
                            </Avatar>
                            <ContactInfo>
                                <TextField
                                    variant="standard"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            setUpdating(true);
                                            e.target.blur();
                                        }
                                    }}
                                    InputProps={{ disableUnderline: true }}
                                    sx={{
                                        '& .MuiInput-root': {
                                            fontSize: '17px',
                                            fontWeight: 700,
                                            color: '#111b21',
                                            padding: 0
                                        }
                                    }}
                                />
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <IconButton
                                        size="small"
                                        href={`https://wa.me/${number}`}
                                        target="_blank"
                                        sx={{ color: '#008069', p: 0 }}
                                    >
                                        <WhatsAppIcon sx={{ fontSize: 16 }} />
                                    </IconButton>
                                    <Typography variant="body2" sx={{ color: '#667781', fontSize: '13px', fontWeight: 500 }}>
                                        {number}
                                    </Typography>
                                </Box>
                            </ContactInfo>
                        </ContactHeader>

                        {/* SECTION 1: ETIQUETAS (TAGS) */}
                        <SectionBox>
                            <SectionHeaderLabel>ETIQUETAS (TAGS)</SectionHeaderLabel>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                {Array.isArray(selectedTags) && selectedTags.map((tag, idx) => {
                                    const tagLabel = typeof tag === 'object' ? (tag.label || tag.name || tag.value) : tag;
                                    return (
                                        <Box
                                            key={idx}
                                            sx={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                backgroundColor: '#f0f2f5',
                                                border: '1px solid #e9edef',
                                                borderRadius: '12px',
                                                px: '12px',
                                                py: '6px',
                                            }}
                                        >
                                            <TagIcon sx={{ fontSize: 14, color: '#111b21', transform: 'rotate(-45deg)' }} />
                                            <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#111b21' }}>
                                                {tagLabel}
                                            </Typography>
                                            <ClearIcon
                                                onClick={() => removeTag(tag)}
                                                sx={{ fontSize: 14, color: '#8696a0', cursor: 'pointer', '&:hover': { color: '#ef4444' } }}
                                            />
                                        </Box>
                                    );
                                })}
                            </Box>
                            <ReactSelectCustom
                                classNamePrefix="react-select"
                                options={etiquetas}
                                value={null}
                                onChange={addTag}
                                placeholder="Añadir etiqueta..."
                                components={{ DropdownIndicator: CustomDropdownIndicator }}
                            />
                        </SectionBox>

                        {/* SECTION 2: INFORMACIÓN DE CONTACTO */}
                        <SectionBox>
                            <SectionHeaderLabel>INFORMACIÓN DE CONTACTO</SectionHeaderLabel>

                            {/* Phone */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', mt: 1 }}>
                                <Box sx={{ width: 40, height: 40, borderRadius: '12px', backgroundColor: '#e6f4ea', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                    <PhoneIcon sx={{ color: '#16a34a', fontSize: 20 }} />
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#8696a0', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
                                        TELÉFONO
                                    </Typography>
                                    <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#111b21' }}>
                                        {formattedPhone}
                                    </Typography>
                                </Box>
                            </Box>
                        </SectionBox>

                        {/* SECTION 3: ESTADO DE TICKET */}
                        <SectionBox>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <SectionHeaderLabel style={{ marginBottom: 0 }}>ESTADO DE TICKET</SectionHeaderLabel>
                                <Chip
                                    label={ticketStatus}
                                    size="small"
                                    sx={{
                                        backgroundColor: '#dcfce7',
                                        color: '#16a34a',
                                        fontWeight: 700,
                                        fontSize: '11px',
                                        height: '22px',
                                        borderRadius: '12px'
                                    }}
                                />
                            </Box>
                            <Box sx={{ backgroundColor: '#f8f9fa', border: '1px solid #f0f2f5', borderRadius: '16px', p: '16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <TicketIcon sx={{ color: '#8696a0', fontSize: 18 }} />
                                    <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#111b21' }}>
                                        Resumen de Soporte
                                    </Typography>
                                </Box>
                                {isJson ? (
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', mt: 1 }}>
                                        {Object.keys(parsedJson).map((key) => (
                                            <Box key={key} sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                                <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#8696a0', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    {key}
                                                </Typography>
                                                <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#111b21' }}>
                                                    {String(parsedJson[key])}
                                                </Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                ) : (
                                    <TextField
                                        multiline
                                        rows={4}
                                        value={notas}
                                        onChange={(e) => setNotas(e.target.value)}
                                        onBlur={() => setUpdating(true)}
                                        variant="outlined"
                                        fullWidth
                                        placeholder="Escribe resumen o notas de soporte aquí..."
                                        sx={{
                                            mt: 1,
                                            '& .MuiOutlinedInput-root': {
                                                backgroundColor: '#ffffff',
                                                borderRadius: '12px',
                                                fontSize: '13px',
                                                '& fieldset': { borderColor: '#e9edef' },
                                                '&:hover fieldset': { borderColor: '#008069' },
                                                '&.Mui-focused fieldset': { borderColor: '#008069' }
                                            }
                                        }}
                                    />
                                )}
                            </Box>
                        </SectionBox>

                        {/* SECTION 5: EJECUTIVO ASIGNADO */}
                        <SectionBox>
                            <SectionHeaderLabel>EJECUTIVO ASIGNADO</SectionHeaderLabel>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                {Array.isArray(ejecutivoAsignado) && ejecutivoAsignado.map((ej, idx) => {
                                    let ejLabel = "";
                                    if (ej) {
                                        if (typeof ej === 'object') {
                                            if (ej.label) {
                                                ejLabel = ej.label;
                                            } else if (ej.firstName || ej.lastName) {
                                                ejLabel = `${ej.firstName || ''} ${ej.lastName || ''}`.trim();
                                            } else if (ej.name) {
                                                ejLabel = ej.name;
                                            } else {
                                                const val = ej.value || ej._id;
                                                const found = ejecutivos.find(item => item.value === val);
                                                ejLabel = found ? found.label : (val || JSON.stringify(ej));
                                            }
                                        } else if (typeof ej === 'string') {
                                            const found = ejecutivos.find(item => item.value === ej);
                                            ejLabel = found ? found.label : ej;
                                        }
                                    }
                                    if (!ejLabel) return null;
                                    return (
                                        <Box
                                            key={idx}
                                            sx={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                backgroundColor: '#f0f2f5',
                                                border: '1px solid #e9edef',
                                                borderRadius: '12px',
                                                px: '12px',
                                                py: '6px',
                                            }}
                                        >
                                            <PersonIcon sx={{ fontSize: 14, color: '#111b21' }} />
                                            <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#111b21' }}>
                                                {ejLabel}
                                            </Typography>
                                            <ClearIcon
                                                onClick={() => removeEjecutivo(ej)}
                                                sx={{ fontSize: 14, color: '#8696a0', cursor: 'pointer', '&:hover': { color: '#ef4444' } }}
                                            />
                                        </Box>
                                    );
                                })}
                            </Box>
                            <ReactSelectCustom
                                classNamePrefix="react-select"
                                options={ejecutivos}
                                value={null}
                                onChange={addEjecutivo}
                                placeholder="Asignar ejecutivo..."
                                components={{ DropdownIndicator: CustomDropdownIndicator }}
                            />
                        </SectionBox>

                        {/* SECTION 6: ENVIAR PLANTILLA */}
                        <SectionBox style={{ borderBottom: 'none' }}>
                            <SectionHeaderLabel>ENVIAR PLANTILLA</SectionHeaderLabel>

                            {plantillaSeleccionada && (
                                <Box
                                    sx={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        backgroundColor: '#e8f5e8',
                                        border: '1px solid #c3e6cb',
                                        borderRadius: '12px',
                                        px: '12px',
                                        py: '8px',
                                        mb: 1
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                        <TemplateIcon sx={{ fontSize: 16, color: '#008069' }} />
                                        <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#008069' }}>
                                            {plantillaSeleccionada.label}
                                        </Typography>
                                    </Box>
                                    <ClearIcon
                                        onClick={() => setPlantillaSeleccionada(null)}
                                        sx={{ fontSize: 14, color: '#008069', cursor: 'pointer', '&:hover': { color: '#ef4444' } }}
                                    />
                                </Box>
                            )}

                            {!plantillaSeleccionada && (
                                <ReactSelectCustom
                                    classNamePrefix="react-select"
                                    options={templates}
                                    value={plantillaSeleccionada}
                                    onChange={selectTemplate}
                                    placeholder="Seleccionar plantilla..."
                                    components={{ DropdownIndicator: CustomDropdownIndicator }}
                                />
                            )}

                            {plantillaSeleccionada && plantillaSeleccionada.value && (
                                <Button
                                    variant="contained"
                                    startIcon={<SendIcon />}
                                    onClick={(e) => props.onSelectTemplate(e, {
                                        name: plantillaSeleccionada.label,
                                        id: plantillaSeleccionada.value,
                                        image: plantillaSeleccionada.image,
                                        video: plantillaSeleccionada.video
                                    })}
                                    sx={{
                                        backgroundColor: '#008069',
                                        borderRadius: '12px',
                                        py: 1,
                                        fontWeight: 600,
                                        textTransform: 'none',
                                        mt: 1,
                                        '&:hover': { backgroundColor: '#006653' }
                                    }}
                                    fullWidth
                                >
                                    {t('sidebar.sendTemplateButton')}
                                </Button>
                            )}
                        </SectionBox>

                        {/* Session Expiration Timers */}
                        {cbp && expirationTimer.map((expTimer, idx) => (
                            <Zoom in={true} timeout={300} key={idx}>
                                <Box sx={{ p: 2, backgroundColor: '#fff8e1', border: '1px solid #ffd54f', borderRadius: '12px', mb: 1 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                        <TimeIcon sx={{ fontSize: 18, color: '#856404' }} />
                                        <Typography variant="body2" sx={{ fontWeight: 700, color: '#856404', fontSize: '13px' }}>
                                            {expirationType[idx]} {t('sidebar.session')}
                                        </Typography>
                                    </Box>
                                    <Typography variant="body2" sx={{ color: '#856404', mb: 1, fontSize: '13px', fontWeight: 500 }}>
                                        {t('sidebar.expiresIn')} {expTimer}
                                    </Typography>
                                    <LinearProgress
                                        variant="determinate"
                                        value={parseInt(expirationWidth[idx])}
                                        sx={{
                                            height: 6,
                                            borderRadius: 3,
                                            backgroundColor: '#ffeaa7',
                                            '& .MuiLinearProgress-bar': {
                                                backgroundColor: '#f39c12',
                                                borderRadius: 3,
                                            },
                                        }}
                                    />
                                </Box>
                            </Zoom>
                        ))}
                    </>
                )}
            </SidebarContainer>
        </Slide>
    );
}